import { NgForm } from '@angular/forms';

export class FormUtil {
  static isValid(form: NgForm): boolean {
    if (form.valid) {
      return true;
    } else {
      Object.keys(form.controls).forEach(key => form.controls[key].markAsTouched());
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/form.util.ts